var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21V19C21 18.4696 21.2107 17.9609 21.5858 17.5858C21.9609 17.2107 22.4696 17 23 17H27C27.5304 17 28.0391 17.2107 28.4142 17.5858C28.7893 17.9609 29 18.4696 29 19V21M16 27C18.7916 28.4067 21.874 29.1394 25 29.1394C28.126 29.1394 31.2084 28.4067 34 27M16 23C16 22.4696 16.2107 21.9609 16.5858 21.5858C16.9609 21.2107 17.4696 21 18 21H32C32.5304 21 33.0391 21.2107 33.4142 21.5858C33.7893 21.9609 34 22.4696 34 23V32C34 32.5304 33.7893 33.0391 33.4142 33.4142C33.0391 33.7893 32.5304 34 32 34H18C17.4696 34 16.9609 33.7893 16.5858 33.4142C16.2107 33.0391 16 32.5304 16 32V23Z",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9489 25.6868L27.8359 26.0618H25.1555L25.2663 25.6868H27.9489ZM26.8643 29L25.1896 27.0334L25.1854 26.7585H25.9183C26.1399 26.7585 26.3288 26.7266 26.4851 26.6626C26.6413 26.5973 26.7607 26.5007 26.843 26.3729C26.9268 26.245 26.9688 26.0866 26.9688 25.8977C26.9688 25.6193 26.8814 25.4006 26.7067 25.2415C26.5334 25.081 26.2848 25.0007 25.9609 25.0007H25.1555L25.2663 24.6364H25.9609C26.2734 24.6364 26.5348 24.6903 26.745 24.7983C26.9567 24.9062 27.1158 25.0554 27.2223 25.2457C27.3303 25.4347 27.3842 25.652 27.3842 25.8977C27.3842 26.1278 27.3324 26.3352 27.2287 26.5199C27.1264 26.7031 26.968 26.8487 26.7536 26.9567C26.5405 27.0632 26.2685 27.1165 25.9375 27.1165H25.7841L27.3608 28.968V29H26.8643ZM27.9638 24.6364L27.853 25.0114L25.5945 25.0007L25.6967 24.6364H27.9638Z",
    fill: "#183883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemat);
export default __webpack_public_path__ + "static/media/Demat.acd43551c246119c7ec460c98406c0f5.svg";
export { ForwardRef as ReactComponent };